import CanvasController from './CanvasController';
import {PanelSection, PropertyRow} from '../ds/ToolFrame.tsx';

interface PencilToolbarProps {
    controller: CanvasController;
}

// The pen's settings, shown above the toolbar while drawing.
const PencilToolbar: React.FC<PencilToolbarProps> = ({controller}) => {
    return (
        <PanelSection title="Pen" className="mx-pencil-panel">
            <PropertyRow label="Line width" htmlFor="pencil-width">
                <input
                    id="pencil-width"
                    className="form-range"
                    type="range"
                    min={0}
                    max={150}
                    step={1}
                    value={controller.pencilWidth}
                    onChange={e => controller.handleLineWidthChange(e)}
                />
                <span className="mx-property-value">{controller.pencilWidth}</span>
            </PropertyRow>
            <PropertyRow label="Shadow width" htmlFor="pencil-shadow">
                <input
                    id="pencil-shadow"
                    className="form-range"
                    type="range"
                    min={0}
                    max={50}
                    step={1}
                    value={controller.shadowWidth}
                    onChange={e => controller.handleShadowWidthChange(e)}
                />
                <span className="mx-property-value">{controller.shadowWidth}</span>
            </PropertyRow>
            <PropertyRow label="Shadow offset" htmlFor="pencil-offset">
                <input
                    id="pencil-offset"
                    className="form-range"
                    type="range"
                    min={0}
                    max={50}
                    step={1}
                    value={controller.shadowOffset}
                    onChange={e => controller.handleShadowOffsetChange(e)}
                />
                <span className="mx-property-value">{controller.shadowOffset}</span>
            </PropertyRow>
        </PanelSection>
    );
};

export default PencilToolbar;
